import { Box, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { mascaraTelefone } from "../../../../utils/mascaras";
import InputMascarado from "../../input-mascarado/InputMascarado";
import Input from "../../input/input"; 

interface ContatoFormProps {
  methods: UseFormReturn<any>;
  disabled?: boolean;
  mdDown?: any;
}

export function ContatoFormPart({
  methods,
  mdDown,
  disabled = false,
}: ContatoFormProps) {
  return (
    <Box>
      <Typography variant="h5" padding="20px 0">
        Contato:
      </Typography>

      <Box
        display="grid"
        gridTemplateColumns={mdDown ? "1fr" : "1fr 1fr 1fr"}
        gap="20px"
        width="100%"
        flexWrap="wrap"
      >
        <Input
          name="email"
          label="E-mail"
          methods={methods}
          disabled={disabled}
        />

        <InputMascarado
          name="contact1"
          methods={methods}
          label="Telefone principal"
          mask={mascaraTelefone}
        />

        <InputMascarado
          name="contact2"
          methods={methods}
          label="Segundo contato"
          mask={mascaraTelefone}
        />
      </Box>
    </Box>
  );
}
